import { useFetch } from "use-http";
import { interpolate } from "react-arc";
import config from "../../../../config/config";

function useBoardDeleteNode({ token, data, baseURL = config.boards.contents }) {
  const url = interpolate(baseURL, data);
  const { del, response, loading, error } = useFetch(url, {
    cacheLife: 0,
    cachePolicy: "no-cache",
    headers: {
      "Content-Type": "application/json",
      "X-Auth-Token": token,
    },
  });

  const handleDelete = ({ node }) => {
    return del("/" + node.id);
  };

  return [error, loading, response, handleDelete];
}

export default useBoardDeleteNode;
